import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-between w-full py-3 pl-10 mt-2 pr-7" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("+")

import { computed, inject, onErrorCaptured, onMounted, ref, toRefs } from 'vue';
import { Participant } from '@/typings/wrestler';
import { useWrestlerStore } from '@/store/wrestlers';
import {
  AnswerResponse,
  MatchResponse,
  ScorecardDisplayState,
  ScorecardViewMode,
} from '@/typings/scorecard';
import Dropdown from '../Inputs/Dropdown.vue';
import { useValidation } from '@/composable/useValidation';
import { useScorecardStore } from '@/store/scorecards';

interface Props {
  response: MatchResponse;
  correctResponse: MatchResponse;
  participants: Array<Participant>;
  type: string;
  disabled?: boolean;
  points: number;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    response: null,
    correctResponse: null,
    participants: null,
    type: null,
    disabled: { type: Boolean },
    points: null
  },
  setup(__props: any) {

const props = __props as {
  response: MatchResponse;
  correctResponse: MatchResponse;
  participants: Array<Participant>;
  type: string;
  disabled?: boolean;
  points: number;
}

const resultsMode = inject('resultsMode');
const viewMode = inject('viewMode');

const store = useWrestlerStore();



const {
  participants,
  type: propType,
  response,
  correctResponse,
  points,
} = toRefs(props);

const answer = ref<number | string | Array<number | string>>(0);

const optionObjects = computed(() => {
  if (propType.value === 'All') {
    return store.wrestlerSearchOptions;
  }

  const wrestlers = [];
  for (const p of participants.value) {
    if (p.Team) {
      wrestlers.push({
        id: p.Team.TeamId,
        text: p.Team.ScorecardName.length ? p.Team.ScorecardName : p.Team.Name,
      });
    }
    if (p.Wrestler) {
      wrestlers.push({ id: p.Wrestler.SuperstarId, text: p.Wrestler.Name });
    }
  }
  return wrestlers.map((w) => ({
    value: w.id,
    text: w.text,
  }));
});

function onUpdate(a: AnswerResponse) {
  if (!a) {
    answer.value = 0;
  }
  response.value.Answer = answer.value;
}

onErrorCaptured((err) => {
  console.error(err);
});

const score = computed(() => {
  if (viewMode === ScorecardViewMode.Public) {
    return `+${points.value}`;
  }
  if (displayState !== ScorecardDisplayState.View || resultsMode) {
    return '';
  }
  if (response.value.State !== undefined) {
    switch (response.value.State) {
      case 1:
        return `+${points.value}`;
      default:
        return '+0';
    }
  }
  return '';
});

const { isPositiveNumber } = useValidation();

onMounted(() => {
  if (!response.value.Answer) {
    answer.value = 0;
  } else if (isPositiveNumber(response.value.Answer)) {
    answer.value = parseInt(response.value.Answer.toString(), 10);
  } else {
    if (participants.value[0].Team) {
      // Get Team ID
    } else {
      const wrester = store.wrestlers.find(
        (w) => w.Name === response.value.Answer
      );
      if (wrester) {
        answer.value = wrester.SuperstarId;
      }
    }
  }
  if (viewMode === ScorecardViewMode.Public) {
    answer.value = correct.value;
  }
});

const wrestlerStore = useWrestlerStore();

const correct = computed(() => {
  if (participants.value && !resultsMode) {
    if (participants.value[0].Team) {
      const team = store.teams.find(
        (t) => t.TeamId === parseInt(correctResponse.value.Answer, 10)
      );
      if (team) {
        return team?.ScorecardName || team?.Name;
      } else if (Array.isArray(correctResponse.value.Answer)) {
        const text = 'Any of ';
        const correctArray = Array.from(correctResponse.value.Answer);
        const correctTeams = correctArray.map((w) => {
          if (isPositiveNumber(w)) {
            const team = wrestlerStore.teams.find(
              (x) => x.TeamId === parseInt(w, 10)
            );
            if (team) {
              return (team.ScorecardName || '').trim().length > 0
                ? team.ScorecardName
                : team.Name;
            }
          }
          return w;
        });
        return `${text} ${correctTeams.join(', ')}`;
      }
    } else if (Array.isArray(correctResponse.value.Answer)) {
      const text = 'Any of ';
      const correctArray = Array.from(correctResponse.value.Answer);
      const correctWrestlers = correctArray.map((w) => {
        if (isPositiveNumber(w)) {
          const wrestler = wrestlerStore.wrestlers.find(
            (x) => x.SuperstarId === parseInt(w, 10)
          );
          if (wrestler) {
            return wrestler.Name;
          }
        }
        return w;
      });
      return `${text} ${correctWrestlers.join(', ')}`;
    } else {
      if (isPositiveNumber(correctResponse.value.Answer)) {
        const wrestler = store.wrestlers.find(
          (t) => t.SuperstarId === parseInt(correctResponse.value.Answer, 10)
        );
        if (wrestler) {
          return wrestler?.Name;
        }
      } else {
        return correctResponse.value.Answer;
      }
    }
  }
  return '';
});

const { displayState } = useScorecardStore();

const hint = computed(() => {
  if (
    displayState === ScorecardDisplayState.View &&
    !resultsMode &&
    score.value == 0
  ) {
    return `Correct: ${correct.value}`;
  }
  return '';
});

function addOption() {
  if (!Array.isArray(answer.value)) {
    answer.value = [answer.value];
  }
  answer.value.push(0);
}

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (Array.isArray(answer.value))
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(answer.value, (a, n) => {
          return (_openBlock(), _createBlock(Dropdown, {
            key: a,
            title: "Winner(s)",
            modelValue: answer.value[n],
            "onUpdate:modelValue": [($event: any) => ((answer.value[n]) = $event), onUpdate],
            items: _unref(store).wrestlerSearchOptions,
            disabled: __props.disabled
          }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "disabled"]))
        }), 128))
      : (_openBlock(), _createBlock(Dropdown, {
          key: 1,
          title: "Winner",
          modelValue: answer.value,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((answer).value = $event)),
            onUpdate
          ],
          items: _unref(optionObjects),
          disabled: __props.disabled,
          status: _unref(score),
          hint: _unref(hint)
        }, null, 8, ["modelValue", "items", "disabled", "status", "hint"])),
    (_unref(resultsMode))
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 2,
          onClick: addOption
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})